import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Outlet, useLocation } from 'react-router-dom';
import { StickySubNav } from '../../components/nav/StickySubNav';
import { getCurrentUser } from '../../services/helper';
import { NavItem } from '../navbar/NavBarItems';
import { SFCMemberRibbon } from './SFCMemberRibbon';
import './UserProfileLayout.css';

interface UserProfileLayoutProps {
    tabs: NavItem[];
    showTitle?: boolean;
}

export const UserProfileLayout: React.FC<UserProfileLayoutProps> = ({ tabs }) => {
    const location = useLocation();
    const user = getCurrentUser();

    const subNavItems = tabs
        .filter((t) => !t.hidden && t.url)
        .map((t) => ({ label: t.title, url: t.url }));

    return (
        <div id="UserProfileLayout">
            <div className="w-100 d-flex flex-column align-items-center section-banner-style-events py-4">
                <h1 className="text-weight-700 text-blue text-center mb-2">
                    Hello, {user ? user.first_name : 'User'}
                </h1>
                <SFCMemberRibbon year={new Date(user?.createdAt ?? Date.now()).getFullYear()} />
            </div>

            {subNavItems.length > 0 && (
                <StickySubNav items={subNavItems} mobileTitle="My Account" />
            )}

            <Container fluid className="m-lg-3 text-start">
                <Outlet />
            </Container>
        </div>
    );
};